import _ from 'lodash'
import { FetchDataUtil } from '@vzmi/component_ec_nodejs_util'
import { idsParser } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import safeAwait from '../../../../lib/safeAwait'
import errorHelper from '../../../../lib/errorHelper'

const MAX_REQUEST_SIZE = 200
const DEFAULT_REQUEST_SIZE = 50

// 取得批次提案的賣場資料
const fetchBatchProposals = async ({ fetchMultipleProposals }, params) => {
  const paramsWithPagination = { ...params, limit: DEFAULT_REQUEST_SIZE, maxResults: MAX_REQUEST_SIZE }
  const [error, payload] = await safeAwait(
    FetchDataUtil.fetchAllPages(fetchMultipleProposals, {
      payload: paramsWithPagination,
      selector: res => _.get(res, 'proposals', [])
    })
  )
  const errorMessage = errorHelper.parseErrorMessage(error)
  if (errorMessage) {
    return [{ message: errorMessage, params }]
  }

  const sortedProposalsFromParams = _.flow(
    // 從 API 回應取得提案
    () => _.get(payload, 'data', []),
    // 以提案編號組成 map
    proposals => _.keyBy(proposals, 'id'),
    // 以查詢參數的賣場編號順序重新排序賣場
    proposalMapById => _.map(idsParser(params.id), id => _.get(proposalMapById, id)),
    // 過濾掉沒有查到的賣場
    sortedProposals => _.filter(sortedProposals, proposal => !_.isEmpty(proposal))
  )()
  return [undefined, sortedProposalsFromParams]
}

export default fetchBatchProposals
